import React from "react";
import militaryImage from '../../images/objets-militaires.jpg';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function MilitairePage() {
    const seo = CATEGORIES_SEO.militaire;
    const details = [
        "Médailles et décorations : Médaille d’Honneur (France, USA), Croix de Guerre, Médaille militaire, Ordre du Mérite militaire.",
        "Uniformes et tenues militaires : Veste d’officier (Napoléon, Première et Seconde Guerre mondiale), capotes et manteaux de cérémonie, casquettes et képis.",
        "Baïonnettes : Baïonnette modèle 1874 (France), Baïonnette de la Première Guerre mondiale (Française, Allemande), Baïonnette M1 (États-Unis, Seconde Guerre mondiale).",
        "Armes à feu (neutralisées) : Fusil Lebel (France, Première Guerre mondiale), Karabiner 98k (Allemagne, Seconde Guerre mondiale), M1 Garand (États-Unis, Seconde Guerre mondiale), Pistolet Luger (Allemagne).",
        "Casques et protections : Casque Adrian (France, Première Guerre mondiale), Casque Stahlhelm (Allemagne), Casque M1 (États-Unis), Casque Brodie (Royaume-Uni).",
        "Épées et sabres : Sabre d’officier (Guerres napoléoniennes), Sabre de cavalerie (Seconde Guerre mondiale), Épée d’honneur (Guerres coloniales, XIXe siècle).",
        "Insignes et décorations : Insigne de régiment, Insigne de la Légion étrangère, Écussons et broderies de divisions militaires.",
        "Documents et archives militaires : Ordres de bataille, journaux de guerre, cartes topographiques des champs de bataille.",
        "Objets de communication militaire : Téléphone de campagne, radio militaire, mégaphone de commandement.",
        "Accessoires divers : Boussoles militaires, montres de poche de l’armée, couteaux de tranchée, rations de combat.",
        "Munitions et charges : Munitions de canons, coques de munitions de la Première Guerre mondiale, munitions de guerre de tranchée.",
        "Véhicules militaires : Maquettes de tanks et blindés, modèles réduits de bateaux de guerre, insignes et plaques d’armées de chars.",
    ];

    return (
        <CategoryPage
            title="Objets Militaires"
            image={militaryImage}
            description="Je suis passionné par les objets militaires de collection, qu'ils soient en excellent état ou nécessitent une restauration. Je m'intéresse particulièrement aux artefacts des grandes guerres, comme les guerres napoléoniennes, la guerre de Sécession, et les deux guerres mondiales. Baïonnettes, casques, épées, insignes, et autres pièces rares sont mes spécialités. Chaque objet est évalué pour son authenticité, son état et son histoire. Contactez-moi pour une évaluation gratuite et confidentielle de vos pièces."
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default MilitairePage;
